import { render } from "./OrganisationPersonModal.vue?vue&type=template&id=537496f3"
import script from "./OrganisationPersonModal.vue?vue&type=script&lang=js"
export * from "./OrganisationPersonModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/MearnsGill/Sites/ICoTA/icota-europe.localhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__